/**
 * Maps a read/display channel to its OPINK consent channel: a phone address's consent lives
 * under the OPINK "Sms" ChannelType (the consent matrix is keyed on it and the write validator
 * accepts it), so "Phone" → "Sms". Reads keep "Phone" — OPINK's `ConsentKey.ResolveChannel`
 * maps it server-side and echoes the raw "Phone" back so the BFF join succeeds.
 */
export function toConsentChannelType(channelType) {
    return channelType === "Phone" ? "Sms" : "Email";
}
/**
 * Whether a contact channel carries a consent surface at all. Only e-mail and phone do — a postal
 * address or a social profile has no `ConsentState` in OPINK.
 *
 * The rule belongs to the consent domain, not to any one screen: it decides what the consent read
 * is asked about (the widget, the tab) AND when that read has to be re-issued. A type predicate so
 * callers narrow `type` from the bare `string` the BFF model declares, with no cast downstream.
 */
export function isConsentRelevantChannel(channel) {
    return channel.type === "Email" || channel.type === "Phone";
}
/** The collection modes offered in the modal, in the order the dropdown lists them. */
export const CONSENT_COLLECTION_MODES = [
    "Form",
    "Verbal",
    "Paper",
    "Import",
];
